import "./styles.css";

export const SkeletonLoader = () => {
  return (
    <div className="skeleton" style={{ width: "100%", height: "100%" }}></div>
  );
};
